// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__aMMWX","link":"Navbar_link__p7+hi"};